import { CacheableDataObject } from 'models/CacheableDataObject.jsx';
import { MatchStocks } from '../models/MatchStocks.jsx';
import { Character } from 'models/Character.jsx';

export class MatchGamePlayer extends CacheableDataObject {

	/**
	 * The character picked, Random included. If the character is not already cached, this will end up returning
	 * null.  So this function isn't trustworthy to always return the correct character data
	 */
	getSelectedCharacterIfLoaded() {
		return this.character ? Character.retrieveById(this.character) || null : null;
	}

	// What a Random pick landed on, once the game has started; null for any other pick.
	getRolledCharacterIfLoaded() {
		return this.random_character ? Character.retrieveById(this.random_character) || null : null;
	}
}

MatchGamePlayer.dataLocationParsers = {
	stocks(player, data) {
		player.stocks = MatchStocks.create(data.stocks);
	}
};
